import React, { useState } from 'react'
import { KonfhubButton } from '../../Atom/Buttons'
import LoadingSpinner from '../../Atom/Loading'
import FormButtons from '../../Molecule/Buttons/FormButtons'
import DETCodesOverview from './DETCodesOverview'
import AttendeeOverview from './AttendeeOverview'

const UploadDETCodeModal = ({
    setOpenDETModal,
    uploadedFile,
    loadModal,
    DETAnalytics,
    loadingUploadFile,
    loadSaveButton,
    uploadUrl,
    getDETCodeURL,
    handleUploadFile,
    showOverview,
    setIsSendConfirmationEmail,
    isSendConfirmationEmail,
    setUploadedFile
}) => {

    return (
        <>
            {loadModal ?
                <div className="d-flex justify-content-center align-items-center">
                    <LoadingSpinner />
                </div> :
                <div className="mt-2 mx-3 justify-content-center">
                    <p className='label'>
                        Upload DET Codes to allocate them to event-registered attendees. The <br />
                        system automatically assigns DET Codes from the available list for new and <br />
                        existing registrations without assigned codes.
                    </p>
                    {/* <p className='label mb-0'><b>Note:</b> DET codes need to be unique.</p> */}
                    {showOverview &&
                        <> <div className='mt-4'>
                            <span className='overview-title'>DET Codes Overview</span >
                            <DETCodesOverview DETAnalytics={DETAnalytics} />
                        </div>
                            <div className='mt-4'>
                                <span className='overview-title'>Attendees Overview</span>
                                <AttendeeOverview DETAnalytics={DETAnalytics} />
                            </div>
                        </>}
                    <div className='d-flex align-items-center justify-content-between mt-4'>
                        <span className='label fontSize '>Step 1: Download sample file</span>
                        <span>
                            <KonfhubButton
                                disabled={false}
                                btnType={"tertiary"}
                                onClick={() => window.location.assign("https://files.konfhub.com/sample-upload-det-codes.xlsx")}
                            >
                                Download Sample
                            </KonfhubButton>
                        </span>
                    </div>
                    <div className='d-flex align-items-center justify-content-between mt-4'>
                        <span>
                            <span className='label fontSize '>Step 2: Upload the sample file with list of DET Codes.<br /></span>
                            <span className='noteText'><b>Note:</b> DET codes need to be unique.</span>
                        </span>
                        <span>
                            <KonfhubButton
                                disabled={loadingUploadFile}
                                btnType={"secondary"}
                                onClick={() => document.getElementById("file-upload").click()}
                            >
                                Attach
                            </KonfhubButton>
                            <input
                                id="file-upload"
                                type="file"
                                accept={".xlsx"}
                                style={{ display: 'none' }}
                                onChange={getDETCodeURL}
                            />
                        </span>
                    </div>
                    {uploadedFile && (
                        <div className="d-flex justify-content-end mt-2">
                            <a
                                href={uploadUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="noteText"
                            >
                                {uploadedFile}
                            </a>
                        </div>
                    )}
                    <div className="d-flex mt-4">
                        <input
                            className='checkbox-input'
                            type="checkbox"
                            checked={isSendConfirmationEmail}
                            onChange={() => setIsSendConfirmationEmail(!isSendConfirmationEmail)}
                        />
                        <span
                            className="noteText"
                        >
                            Send a registration confirmation email to attendees, including their updated ticket with the assigned DET Code
                        </span>
                    </div>
                    <FormButtons
                        isLoading={loadSaveButton}
                        saveBtnContent={"Upload"}
                        saveBtnDisabled={loadSaveButton || !uploadUrl}
                        onSave={() => {
                            handleUploadFile()
                        }}
                        onCancel={() => {
                            setOpenDETModal(false)
                            setIsSendConfirmationEmail(false)
                            setUploadedFile(null)
                        }}
                    />
                </div>
            }

            <style jsx>{`
                .noteText {
                    font-family: Hind;
                    font-size: 15px;
                    font-weight: 400;
                    line-height: 24px;
                }
                .checkbox-input {
                    width: 30px !important;
                    margin-top: 3px;
                }
            `}</style>
        </>
    )
}

export default UploadDETCodeModal